import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Components/GlobalComponent/Header';
import OurServicesNew from '../Components/HomeComponent/OurServicesNew';
import Banner from '../Components/HomeComponent/Banner';
import Reviews from '../Components/GlobalComponent/Reviews';
import Footer from '../Components/GlobalComponent/Footer';
import AllProjects from '../Components/HomeComponent/AllProjects';

const HomePage = () => {
    return (
        <div className=''>
            <Header/>
            <Banner/>
            <OurServicesNew/>
            <AllProjects limit={3}/>
            <Reviews/>
            <Footer/>
        </div>
    );
};

export default HomePage;
